import { SBaseDisplay } from '@summit/core';

import { EboObject } from '../base-classes/ebo-object';
import { Company } from '../organization/company/company';
import { Employee } from './employee';

export class EmployeePayrollInfo extends EboObject implements SBaseDisplay {
  employeeID: string;
  employee: Employee;
  companyID: string;
  company: Company;
  payrollGroup: string;
  payrollId: string;
  workersCompId: string;
  customField1: string;
  customField2: string;
  customField3: string;

  constructor(jsonData?: Partial<EmployeePayrollInfo>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData?.employee) this.employee = new Employee(jsonData?.employee);
      if (jsonData?.company) this.company = new Company(jsonData?.company);
    }
  }
  toShortString(): string {
    return `${this.company?.name}: ${this.employee?.name}: ${this.payrollId}`;
  }
}
